<template>
  <div id="app">
    <svgsprites></svgsprites>
    <navigation></navigation>
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue'
import SvgSprites from '@/components/SvgSprites'
import Navigation from '@/components/Navigation'

Vue.component('svgsprites', SvgSprites)
Vue.component('navigation', Navigation)

export default {
  name: 'App',
  metaInfo: {
    titleTemplate: '%s｜原案 直木賞作家 道尾秀介'
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/App.vue